import { Component, OnInit } from '@angular/core';
import { AbstractBreezeListComponent } from '@common/classes/breeze-list';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { PrintService } from '@common/services/print.service';

@Component({
    selector: 'app-vessel-notification-passenger-print',
    templateUrl: './vessel-notification-passenger-print.component.html',
    styleUrls: ['./vessel-notification-passenger-print.component.scss'],
    providers: [BreezeViewService]
})
export class VesselNotificationPassengerPrintComponent extends AbstractBreezeListComponent implements OnInit {
    queryName = 'PassengerList';
    parentRoute = 'vessel-notification';
    vesselNotificationIds: number[];
    pdfPaxData: any;
    passengerList: any[][] = [];

    constructor(public breezeViewService: BreezeViewService, private printService: PrintService) {
        super(breezeViewService);
        this.vesselNotificationIds = this.breezeViewService.activatedRoute.snapshot.params.ids.split(',').map(id => +id);
    }

    override getDefaultFilter() {
        return { id: this.vesselNotificationIds[0] };
    }

    override search() {
        const query = this.getQuery();
        this.entityManager.executeQuery(query)
            .then((response) => {
                this.pdfPaxData = response.results[0];
                const paxList = this.pdfPaxData.passengers;
                while (paxList.length > 0) this.passengerList.push(paxList.splice(0, 22));
                this.printService.onPrintReady();
            })
            .catch(e => console.error(e));
        return query;
    }
}
